import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Clock, XCircle, Loader2 } from "lucide-react";
import { api, money } from "../../lib/api";

const VIEW = {
  succeeded: { icon: CheckCircle2, cls: "text-emerald-600", title: "Payment received", text: "Thank you! Your payment has been applied to your booking and a confirmation email is on its way." },
  processing: { icon: Clock, cls: "text-amber-600", title: "Bank payment submitted", text: "Your bank payment is on its way. Bank (ACH) payments usually take up to 4 business days to clear. We'll email you once it's confirmed." },
  failed: { icon: XCircle, cls: "text-red-600", title: "Payment didn't go through", text: "No money was taken. Please try again from your booking or use a different payment method." },
  expired: { icon: XCircle, cls: "text-slate-500", title: "Checkout not completed", text: "This checkout was closed before payment. No money was taken. You can start a new payment from your booking." },
  slow: { icon: Clock, cls: "text-amber-600", title: "Still confirming", text: "Stripe hasn't confirmed this payment yet. Please check your booking in a few minutes; we'll email you once it's confirmed." },
};

export default function PaymentResult() {
  const [sp] = useSearchParams();
  const sid = sp.get("session_id");
  const [p, setP] = useState(null);
  const [tries, setTries] = useState(0);
  useEffect(() => {
    if (!sid) return undefined;
    const tm = setTimeout(() => {
      api.get(`/payments/stripe-status/${sid}`).then((r) => { setP(r.data); if (r.data.status === "pending" && tries < 15) setTries((t) => t + 1); }).catch(() => setP({ status: "error" }));
    }, tries ? 2000 : 0);
    return () => clearTimeout(tm);
  }, [sid, tries]);
  const v = p && (VIEW[p.status] || (p.status === "pending" && tries >= 15 ? VIEW.slow : null));
  const missing = !sid || p?.status === "error";
  return (
    <div className="container-x max-w-lg py-20 text-center" data-testid="payment-result">
      {!v ? (
        <div data-testid="payment-checking">{!missing && <Loader2 className="mx-auto h-10 w-10 animate-spin text-slate-400" />}<p className="mt-4 text-slate-600">{missing ? "We couldn't check this payment. Please open your booking to see its status." : "Confirming your payment…"}</p></div>
      ) : (
        <div className="card p-8">
          <v.icon className={`mx-auto h-12 w-12 ${v.cls}`} />
          <h1 className="mt-4 font-display text-3xl font-semibold" data-testid="payment-result-title">{v.title}</h1>
          <p className="mt-2 font-display text-4xl" data-testid="payment-result-amount">{money(p.amount)}</p>
          <p className="mt-3 text-sm text-slate-600">{v.text}</p>
        </div>
      )}
      <Link to={p?.booking_id ? `/portal/bookings/${p.booking_id}` : "/portal"} className="btn-primary mt-8 inline-flex" data-testid="payment-back-to-booking">Back to my booking</Link>
    </div>
  );
}
